"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJwtExpired = void 0;
/**
 * Decodes a base64Url encoded string to JSON object of type T
 * @param base64UrlStr The base64Url encoded string
 * @returns The decoded JSON object of type T
 */
const base64UrlDecode = (base64UrlStr) => {
    const base64 = base64UrlStr.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = Buffer.from(base64, 'base64').toString('utf8');
    return JSON.parse(jsonPayload);
};
/**
 * Checks if a JWT is expired
 * @param token The JWT string
 * @returns False if the token is not expired or doesn't have exp, true otherwise
 */
const isJwtExpired = (token) => {
    try {
        if (!token) {
            return true;
        }
        const [, payload] = token.split('.');
        if (!payload) {
            return true;
        }
        const { exp } = base64UrlDecode(payload);
        if (!exp) {
            return false;
        }
        const currentTime = Math.floor(Date.now() / 1000);
        return currentTime >= exp;
    }
    catch (error) {
        return true;
    }
};
exports.isJwtExpired = isJwtExpired;
//# sourceMappingURL=index.js.map